/**
 * Модель для работы с авторизацией пользователя
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';
import UsersService from '../services/UsersService';
import LocalStorageService from '../services/LocalStorageService';

import webSsoConstants from '../constants/webSsoConstants';
import { paths } from '../routes/Root/paths';
import config from '../containers/SecurableTree/config';

import { jwtDecode } from 'jwt-decode';

interface IState {
  isAuth: boolean;
  webSSO: boolean;
}

const initialState: IState = {
  isAuth: false,
  webSSO: false
};

export const auth = createModel<RootModel>()({
  state: initialState,
  reducers: {
    login(state: IState): IState {
      return { ...state, isAuth: true };
    },
    logout(state: IState): IState {
      return { ...state, isAuth: false };
    },
    webSSOTurnOn(state: IState): IState {
      return { ...state, webSSO: true };
    },
    webSSOTurnOff(state: IState): IState {
      return { ...state, webSSO: false };
    }
  },
  effects: (dispatch: any): any => ({
    async initialLogin(code: any) {
      try {
        const { data } = await UsersService.getToken(code);

        LocalStorageService.setToken(data);

        dispatch.auth.onLogin();
      } catch (error) {
        return error;
      }
    },
    async submitLogin(body: any) {
      try {
        const {
          data: { access_token, refresh_token, token_type }
        } = await UsersService.login(body);

        LocalStorageService.setToken({ access_token, refresh_token, token_type });

        dispatch.auth.onLogin();
      } catch (error) {
        return error;
      }
    },
    async onLogin() {
      try {
        const { accessToken } = LocalStorageService.getToken();
        if (accessToken) {
          try {
            const decoded = jwtDecode<any>(accessToken);
            dispatch.user.setUser(decoded);
          } catch (error) {
            console.error('Ошибка декодирования токена', error);
            return null;
          }
        }
        dispatch.admin.getCompanyConfig();
        dispatch.securable.getSecurables(config);
        dispatch.auth.login();
      } catch (error) {
        return error;
      }
    },
    onLogout() {
      // сброс стора
      (dispatch as any)({ type: 'resetStore' });

      LocalStorageService.clearToken();

      if (initialState.webSSO) {
        window.location.replace(webSsoConstants.logoutUrl);
      } else {
        window.location.replace(paths.map.root);
      }

      dispatch.auth.logout();
    }
  })
});
